module.exports = __webpack_public_path__ + "static/img/kuajingvs-logo.7607948e.png";